import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React from 'react';
import PropTypes, { bool, string } from 'prop-types';

const gearedGrabbedMap = {
    geared: {
        name: 'geared',
        notSet: 'Gears not set',
        isTrue: 'Geared',
        isFalse: 'Gearless',
    },
    grabbed: {
        name: 'grabbed',
        notSet: 'Grabs not set',
        isTrue: 'Grabbed',
        isFalse: 'Grabless',
    },
};

/**
 * 
 * @param {{
 *  gearedGrabbed: boolean | null, 
 *  fieldName: string, 
 *  confirmed: boolean, 
 *  modifiedFields?: string[],
 *  styles: React.CSSProperties,
 *  onChange: Function
 * }} param0 
 * @returns 
 */
export default function GearedGrabbed({ gearedGrabbed = null, fieldName, confirmed, modifiedFields, styles, onChange }) {    
    return (
        <SelectField
            value={gearedGrabbed}
            style={{ margin: `${gearedGrabbed === null ? '-20px' : '-35px'} 0 -25px 0` }}
            onChange={(e, i, value) => onChange(value)}
            disabled={!confirmed}
            name={gearedGrabbedMap[fieldName].name}
            floatingLabelText={gearedGrabbed !== null && gearedGrabbedMap[fieldName].isTrue}
            underlineStyle={modifiedFields && modifiedFields.includes(gearedGrabbedMap[fieldName].name) ? styles.underlineStyle : null}
            fullWidth
        >
            <MenuItem value={null} primaryText={gearedGrabbedMap[fieldName].notSet} />
            <MenuItem value={true} primaryText={gearedGrabbedMap[fieldName].isTrue} />
            <MenuItem value={false} primaryText={gearedGrabbedMap[fieldName].isFalse} />
        </SelectField>
    );    
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/GearedGrabbed.jsx